import { render, staticRenderFns } from "./discount-specified.vue?vue&type=template&id=1e86d607&scoped=true&"
import script from "./discount-specified.vue?vue&type=script&lang=js&"
export * from "./discount-specified.vue?vue&type=script&lang=js&"
import style0 from "./discount-specified.vue?vue&type=style&index=0&id=1e86d607&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e86d607",
  null
  
)

export default component.exports